module.exports = __webpack_public_path__ + "static/img/s8.4058fed9.png";